import { axiosInstance } from "../axios";

export const bangTinApi = {
  getSummary: () => axiosInstance.get("/news-feed/summary"),
  getImportTotalRecentDays: () =>
    axiosInstance.get("/news-feed/recent-import-total"),
  getExportTotalRecentDays: () =>
    axiosInstance.get("/news-feed/recent-export-total"),
  getPosts: async (params) => {
    try {
      const res = await axiosInstance.get("/news-feed", { params });
      return res?.data ?? { items: [], total: 0 };
    } catch (e) {
      return { items: [], total: 0 };
    }
  },
  getPostDetail: async (id) => {
    const res = await axiosInstance.get(`/news-feed/${id}`);
    return res?.data?.data || res?.data || null;
  },
  createPost: async (data) => {
    const res = await axiosInstance.post("/news-feed", data);
    return res?.data?.data || res?.data || res;
  },
  updatePost: async (id, data) => {
    const res = await axiosInstance.put(`/news-feed/${id}`, data);
    return res?.data?.data || res?.data || res;
  },
  deletePost: async (id) => {
    const res = await axiosInstance.delete(`/news-feed/${id}`);
    return res?.data?.data || res?.data || res;
  },

  // =================== PHẦN DASHBOARD ===================
  // 1. Tổng tiền tồn kho theo kỳ (ngày/tháng/năm) theo từng chi nhánh
  getInventoryValue: (params) =>
    axiosInstance.get("/backlog-forms/inventory-value", { params }),

  // 2. Tổng tiền mua hàng theo kỳ (ngày/tháng/năm) theo từng chi nhánh
  getPurchaseValue: (params) =>
    axiosInstance.get("/purchase-forms/purchase-value", { params }),

  // 3. Chi tiết tồn kho theo kỳ (day: tối đa 7 ngày, month: tối đa 6 tháng, year: tối đa 6 năm)
  getInventoryValueDetail: (params) =>
    axiosInstance.get("/backlog-forms/inventory-value/detail", { params }),

  // 4. Chi tiết tồn kho theo nguyên vật liệu của 1 cửa hàng trong 1 ngày
  getInventoryValueByStoreDay: (params) =>
    axiosInstance.get("/backlog-forms/inventory-value/store-day", { params }),

  // 5. Tổng tiền định mức tồn kho theo chi nhánh
  getStockThresholdValue: (params) =>
    axiosInstance.get("/stock-thresholds/value", { params }),

  // 6. Chi tiết định mức tồn kho theo nguyên vật liệu của 1 chi nhánh
  getStockThresholdValueDetail: (params) =>
    axiosInstance.get("/stock-thresholds/value/detail", { params }),
};
